import { render, staticRenderFns } from "./NsCarousel.vue?vue&type=template&id=64dc8be4&scoped=true&"
import script from "./NsCarousel.vue?vue&type=script&lang=js&"
export * from "./NsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./NsCarousel.vue?vue&type=style&index=0&id=64dc8be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dc8be4",
  null
  
)

export default component.exports